import React from "react";
import { useDispatch } from "react-redux";
import { showRequestListBox, showTransferEmailBox } from "./coeSlice";
function COE() {
  const dispatch = useDispatch();
  return (
    <div className="mt-2 mb-2 grid grid-cols-3 grid-auto-rows  mr-6 h-full  xl:w-4/12 w-full">
      <div className="h-1 w-full bg-black col-span-3"></div>
      <div className="text-center text-xl  col-span-3">
        Custodian of Evidence (COE)
      </div>
      <div className="p-2 col-span-3">
        Pursuant to S.C. Code &section;17-28-330(A), an option has been added to
        the inmate search results to allow authorized law enforcement agencies
        to register for custodian of evidence notifications for the inmate.
      </div>
      <div className="flex col-span-3 pb-2 m-auto">
        <button
          type="button"
          onClick={() => {
            dispatch(showRequestListBox());
          }}
          className="items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
        >
          COE Registration List Request
        </button>
        <button
          type="button"
          onClick={() => {
            dispatch(showTransferEmailBox());
          }}
          className="items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
        >
          COE Registration Transfer Request
        </button>
      </div>
      <div className="h-1 w-full bg-black col-span-3"></div>
    </div>
  );
}

export default COE;
